module.exports = __webpack_public_path__ + "assets/img/how-to-donate-mobile-img-5.4c553c59.jpg";